import axios from "axios";

const api = axios.create({
  baseURL:
    process.env.REACT_APP_API_URL ||
    "https://corporator-backend.onrender.com",

  headers: {
    "Content-Type": "application/json",
  },
});

console.log("API URL:", process.env.REACT_APP_API_URL);

/* =========================================================
   REQUEST INTERCEPTOR
========================================================= */

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("corporator_token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },

  (error) => Promise.reject(error)
);

/* =========================================================
   RESPONSE INTERCEPTOR
========================================================= */

api.interceptors.response.use(
  (response) => response,

  (error) => {
    const status = error.response?.status;
    const url = error.config?.url || "";

    /*
     * Authentication endpoints must handle their own
     * errors.
     *
     * DO NOT redirect to /login when OTP or 2FA fails.
     */
    const isAuthEndpoint =
      url.includes("/auth/login") ||
      url.includes("/auth/register") ||
      url.includes("/auth/request-otp") ||
      url.includes("/auth/verify-otp") ||
      url.includes("/auth/verify-2fa");

    /* =====================================================
       SESSION EXPIRATION
       Only redirect for protected/non-auth API requests.
    ===================================================== */

    if (
      (status === 401 || status === 403) &&
      !isAuthEndpoint
    ) {
      console.log("Session expired or unauthorized");

      localStorage.removeItem("corporator_token");

      window.location.href = "/login";
    }

    return Promise.reject(error);
  }
);

export default api;